import React, { useEffect } from "react";
import axios from "axios";

declare global {
  interface Window {
    getGoogleSearch: (param: any) => void;
    getGoogleSearchV2: (param: any) => void;
    getAmazonSearch: (param: any) => void;
  }
}

const host:any={
    google:process.env.REACT_APP_GOOGLE_API,
  googleV2:process.env.REACT_APP_GOOGLEV2_API,
  json:process.env.REACT_APP_JSON_API
}

const InitiateGoogleAmazonApiConfig = () => {
  const initiatePayload = () => {
    window.getGoogleSearch = (param: any) => {
      return axios.get("/api/google/search?" + param).then((res) => res);
    };

    window.getGoogleSearchV2 = (param: any) => {
        console.log('getGoogleSearchV2');
        console.log('host',host);
        axios.get("/googleV2?" + param).then((res) => console.log('googleV2 without .env',res));
        axios.get(host.googleV2?.concat(`?${param}`)).then((res) => console.log('googleV2 with .env',res));
        axios.get(host.json).then((res) => console.log('json place',res));
      return axios.get(host.googleV2?.concat(`?${param}`)).then((res) => res);
    };

    window.getAmazonSearch = (param: any) => {
      return axios.get("/api/amazon/search?" + param).then((res) => res);
    };
  };

  useEffect(() => {
    initiatePayload();
  }, []);

  return null;
};

export default InitiateGoogleAmazonApiConfig;
